import { Component, OnInit } from '@angular/core';
import { DashboardService } from '../../services/dashboard.service';
import { ParamMap, ActivatedRoute, Router } from '@angular/router';
@Component({
  selector: 'app-student-profile',
  templateUrl: './student-profile.component.html',
  styleUrls: ['./student-profile.component.scss']
})
export class StudentProfileComponent implements OnInit {

  apiResponse;

  studentId;

  constructor(private dashboardService: DashboardService, private activatedRoute: ActivatedRoute, private router: Router) {

    this.activatedRoute.paramMap.subscribe((params: ParamMap) => this.studentId = (params.get('student_id')));

    if (isNaN(this.studentId)) {
      this.router.navigate(['/student-list']);
    }
  }

  ngOnInit() {

    this.dashboardService.studentInfo({ student_id: this.studentId }).subscribe(response => {
      if (response.status == false && response.statusCode == 200) {
        this.router.navigate(['/student-list']);
      }
      else if (response.status == true && response.statusCode == 200) {
        this.apiResponse = response.data;
        this.dashboardService.setProfileTabFlag('info');
      }
    });
  }

  setFlag(data) {
    this.dashboardService.setProfileTabFlag(data);
  }
}
